<!--
    描述：
    时间：2020-05-13
    Created by zwh
-->
<template>
    <div class="w-content">
        <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="80px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="objectForm.title" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="版本号">
                        <el-input v-model="objectForm.versionNumText" autocomplete="off" disabled :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div class="editor">
                        <div ref="toolbar" class="toolbar">
                        </div>
                        <div ref="editor" class="text">
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-form>

    </div>
</template>

<script>
    import {saveOrUpdateVersion,getVersionInfoById} from 'api/system/sys.js'
    import E from 'wangeditor'
    export default {
        components: {},
        props : {
            mode: {
                type: String,
                default: 'add'
            },
            transObj: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                //富文本插件对象
                editor : null,

                objectForm : {
                    title : '',
                    versionNumText : '自动生成',
                    content : '',
                },
                formRules : {
                     title: [{required: true, message: '请输入...', trigger: 'blur'}],
                },

            }
        },
        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            }
        },
        mounted() {
            //初始化富文本编辑器
            this.setEditor()
        },
        watch: {},
        created() {
            if (this.mode !== 'add') this.getObjectById()
        },
        methods: {
            //保存
            doSave(){
                let that = this
                this.$refs['objectForm'].validate((valid) => {
                    if (valid) {
                        let content = that.editor.txt.text()
                        if(content.replace(/(^\s+)|(\s+$)/g, "") == ''){
                            that.$message({message: '请输入内容！',type: 'warning'});
                            return
                        }
                        let param = this.objectForm;
                        param.content = that.editor.txt.html()
                        saveOrUpdateVersion(param).then(res => {
                            if(res.operationCode==1){
                                that.$message({message: '保存成功',type: 'success'});
                                //刷新列表信息
                                that.$emit('handle-success')
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            //根据id，获取版本信息
            getObjectById(){
                let that = this
                let param = { id : this.transObj.id }
                getVersionInfoById(param).then(res => {
                    if(res.operationCode==1){
                        res.data != null && res.data != '' ? this.objectForm = res.data : ''
                        that.objectForm.versionNumText = this.objectForm.versionNum
                        that.editor.txt.html(that.objectForm.content)
                    }
                });
            },
            //富文本编辑器
            setEditor() {
                // http://192.168.2.125:8080/admin/storage/create
                this.editor = new E(this.$refs.toolbar, this.$refs.editor)
                this.editor.customConfig.uploadImgShowBase64 = false // base 64 存储图片
                this.editor.customConfig.uploadImgServer = 'http://otp.cdinfotech.top/file/upload_images'// 配置服务器端地址
                this.editor.customConfig.uploadImgHeaders = { }// 自定义 header
                this.editor.customConfig.uploadFileName = 'file' // 后端接受上传文件的参数名
                this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
                this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
                this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间

                // 配置菜单
                this.editor.customConfig.menus = [
                  'head', // 标题
                  'bold', // 粗体
                  'fontSize', // 字号
                  'fontName', // 字体
                  'italic', // 斜体
                  'underline', // 下划线
                  'strikeThrough', // 删除线
                  'foreColor', // 文字颜色
                  'backColor', // 背景颜色
                  //'link', // 插入链接
                  //'list', // 列表
                  'justify', // 对齐方式
                  'quote', // 引用
                  //'emoticon', // 表情
                  //'image', // 插入图片
                  //'table', // 表格
                  //'video', // 插入视频
                  //'code', // 插入代码
                  'undo', // 撤销
                  'redo', // 重复
                  'fullscreen' // 全屏
                ]

                this.editor.customConfig.uploadImgHooks = {
                    fail: (xhr, editor, result) => {
                        // 插入图片失败回调
                    },
                    success: (xhr, editor, result) => {
                        // 图片上传成功回调
                    },
                    timeout: (xhr, editor) => {
                        // 网络超时的回调
                    },
                    error: (xhr, editor) => {
                        // 图片上传错误的回调
                    },
                    customInsert: (insertImg, result, editor) => {
                        // 图片上传成功，插入图片的回调
                        //result为上传图片成功的时候返回的数据，这里我打印了一下发现后台返回的是data：[{url:"路径的形式"},...]
                        // console.log(result.data[0].url)
                        //insertImg()为插入图片的函数
                        //循环插入图片
                        // for (let i = 0; i < 1; i++) {
                        // console.log(result)
                        let url = "http://otp.cdinfotech.top"+result.url
                        insertImg(url)
                        // }
                    }
                }
                this.editor.customConfig.onchange = (html) => {
                    this.info_ = html // 绑定当前逐渐地值
                    this.$emit('change', this.info_) // 将内容同步到父组件中
                }
                // 创建富文本编辑器
                this.editor.create()
                //查看
                this.mode == 'view' ? this.editor.$textElem.attr('contenteditable', false): '';
            }
        }
    }
</script>

<style scoped>
    .editor {
        width: 100%;
        margin: 0 auto;
        position: relative;
        z-index: 0;
    }
    .toolbar {
        border: 1px solid #ccc;
    }
    .text {
        border: 1px solid #ccc;
        height: 360px;
    }
</style>